import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';
import { usePickPackFeatureEnabled } from '../feature-flags/hooks/use-pick-pack-feature-enabled';

export const useEnableOrderPickerRole = () => {
  const hasAdminRole = useSelector(Global.selectUserhasAdministrationRole);
  const hasOrderManagementRole = useSelector(Global.selectUserhasOrderManagementRole);
  const hasCorrectRole = hasAdminRole || hasOrderManagementRole;

  const isFeatureEnabled = usePickPackFeatureEnabled();

  return hasCorrectRole && isFeatureEnabled;
};
